import request from '@/utils/request'


// 查询商家类型列表
export function listBusinessType(query) {
  return request({
    url: '/biz/admin/merchant/level/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家类型分页
export function pageBusinessType(query) {
  return request({
    url: '/biz/admin/merchant/level/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家类型详细
export function getBusinessType(data) {
  return request({
    url: '/biz/admin/merchant/level/detail',
    method: 'get',
    params: data
  })
}

// 新增商家类型
export function addBusinessType(data) {
  return request({
    url: '/biz/admin/merchant/level/add',
    method: 'post',
    data: data
  })
}

// 修改商家类型
export function updateBusinessType(data) {
  return request({
    url: '/biz/admin/merchant/level/edit',
    method: 'post',
    data: data
  })
}

// 删除商家类型
export function delBusinessType(data) {
  return request({
    url: '/biz/admin/merchant/level/delete',
    method: 'post',
    data: data
  })
}
